var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row-container" },
    [
      _c("div", { staticClass: "icon-service-container" }, [
        _c("div", { staticClass: "icon-service-block" }, [
          _c("img", {
            staticClass: "icon-service",
            attrs: { src: _vm.getProfPhoto }
          }),
          _vm._v(" "),
          !_vm.xlScreen
            ? _c("div", { staticClass: "inline-block" }, [
                _vm.petName || _vm.changeUserEnabled
                  ? _c("div", { class: { "inline-block": _vm.petName } }, [
                      _vm.petName
                        ? _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.petName) }
                          })
                        : _vm.changeUserEnabled
                        ? _c("div", [
                            _vm._v("(" + _vm._s(_vm.patientName) + ") "),
                            _c("span", {
                              staticClass: "change-user",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("changeUser"))
                              },
                              on: {
                                click: function($event) {
                                  _vm.showChangeUserAdvice = true
                                }
                              }
                            })
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { class: { "inline-block": _vm.petName } }, [
                  _vm.profName
                    ? _c("a", {
                        staticClass: "prof-name",
                        class: { "cursor-default": _vm.profSearchDisabled },
                        attrs: { href: _vm.profPage, target: "_blank" },
                        domProps: { innerHTML: _vm._s(_vm.profName) }
                      })
                    : _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$t("unassigned")) }
                      }),
                  _vm.historyShared
                    ? _c(
                        "span",
                        {
                          attrs: {
                            title: _vm.$t("historySharedWithProfessional")
                          }
                        },
                        [_vm._v(" "), _c("b-icon-file-earmark-arrow-up")],
                        1
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "details" }, [
        !_vm.xlScreen
          ? _c("div", [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.consultationTitle) }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "appointment-id" }, [
                _vm._v("(ID: " + _vm._s(_vm.id) + ")")
              ])
            ])
          : _c("div", [
              _vm.petName || _vm.changeUserEnabled
                ? _c("div", { class: { "inline-block": _vm.petName } }, [
                    _vm.petName
                      ? _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.petName) }
                        })
                      : _vm.changeUserEnabled
                      ? _c("div", [
                          _vm._v("(" + _vm._s(_vm.patientName) + ") "),
                          _c("span", {
                            staticClass: "change-user",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("changeUser"))
                            },
                            on: {
                              click: function($event) {
                                _vm.showChangeUserAdvice = true
                              }
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { class: { "inline-block": _vm.petName } }, [
                _vm.profName
                  ? _c("a", {
                      staticClass: "prof-name",
                      class: { "cursor-default": _vm.profSearchDisabled },
                      attrs: { href: _vm.profPage, target: "_blank" },
                      domProps: { innerHTML: _vm._s(_vm.profName) }
                    })
                  : _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.$t("unassigned")) }
                    }),
                _vm.historyShared
                  ? _c(
                      "span",
                      {
                        attrs: {
                          title: _vm.$t("historySharedWithProfessional")
                        }
                      },
                      [_vm._v(" "), _c("b-icon-file-earmark-arrow-up")],
                      1
                    )
                  : _vm._e()
              ])
            ]),
        _vm._v(" "),
        _c("div", [
          _c("span", {
            staticClass: "clickable",
            domProps: { innerHTML: _vm._s(_vm.getDateFormatted(_vm.date)) },
            on: { click: _vm.goAppointmentDetailsView }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.showStateTitle
        ? _c("div", { staticClass: "state" }, [
            _vm.xlScreen
              ? _c("div", { staticClass: "consultation-title" }, [
                  _c("span", {
                    attrs: { title: _vm.consultationTitle },
                    domProps: { innerHTML: _vm._s(_vm.consultationTitle) }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "appointment-id", attrs: { title: _vm.id } },
                    [_vm._v("(ID: " + _vm._s(_vm.id) + ")")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.stateTitle
              ? _c("div", {
                  attrs: { title: _vm.stateTitle },
                  domProps: { innerHTML: _vm._s(_vm.stateTitle) }
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.actionButtons.length > 0
        ? _c("div", { staticClass: "actions" }, [
            _vm.actionButtons.length <= 2 || !_vm.xlScreen
              ? _c(
                  "div",
                  _vm._l(_vm.actionButtons, function(item) {
                    return _c(
                      "base-button",
                      {
                        key: item.title,
                        attrs: {
                          transparent: !item.backgroundColor,
                          backgroundColor: item.backgroundColor,
                          borderColor: item.borderColor,
                          textColor: item.textColor
                        },
                        on: { click: item.action }
                      },
                      [
                        _c(
                          "span",
                          { class: "" + (item.blink ? "blink" : "") },
                          [_vm._v(_vm._s(item.title))]
                        )
                      ]
                    )
                  }),
                  1
                )
              : _c(
                  "div",
                  [
                    _vm._l(_vm.actionButtons.slice(0, 1), function(item) {
                      return _c(
                        "base-button",
                        {
                          key: item.title,
                          attrs: {
                            transparent: !item.backgroundColor,
                            backgroundColor: item.backgroundColor,
                            borderColor: item.borderColor,
                            textColor: item.textColor
                          },
                          on: { click: item.action }
                        },
                        [
                          _c(
                            "span",
                            { class: "" + (item.blink ? "blink" : "") },
                            [_vm._v(_vm._s(item.title))]
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "base-button",
                      {
                        attrs: {
                          id: "more-options-" + _vm.id,
                          transparent: "",
                          borderColor: _vm.GRAY_COLOUR,
                          textColor: _vm.GRAY_COLOUR
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("showOptions")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        attrs: {
                          target: "more-options-" + _vm.id,
                          triggers: "click blur",
                          placement: "top"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "popover-container" },
                          _vm._l(_vm.actionButtons.slice(1), function(item) {
                            return _c(
                              "base-button",
                              {
                                key: item.title,
                                staticClass: "my-3 block",
                                attrs: {
                                  transparent: !item.backgroundColor,
                                  backgroundColor: item.backgroundColor,
                                  borderColor: item.borderColor,
                                  textColor: item.textColor
                                },
                                on: { click: item.action }
                              },
                              [
                                _c(
                                  "span",
                                  { class: "" + (item.blink ? "blink" : "") },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ]
                    )
                  ],
                  2
                )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("changeUserAdvice"),
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          okFn: function() {
            return _vm.changeUser(_vm.patientId)
          },
          cancelFn: function() {
            return (_vm.showChangeUserAdvice = false)
          }
        },
        model: {
          value: _vm.showChangeUserAdvice,
          callback: function($$v) {
            _vm.showChangeUserAdvice = $$v
          },
          expression: "showChangeUserAdvice"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf059ae0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf059ae0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AppointmentRowPatient.vue
// module id = 3066
// module chunks = 46 47